import React from "react";
import styles from "./QuickSearch.module.css";
import { TextField } from "@fluentui/react";
import { Stack, StackItem } from "@fluentui/react/lib/Stack";
import { Dropdown } from "@fluentui/react/lib/Dropdown";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { useState, useEffect } from "react";
import { Filter20Filled, FluentIconsProps } from "@fluentui/react-icons";

initializeIcons();


function QuickSearch(props: any) {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedColumn, setSelectedColumn] = useState("");
  const [itemsSearch, setItemsSearch] = useState([...props.items]);
  useEffect(() => {
    props.onItemsProcessed(itemsSearch);
  }, [itemsSearch]);

  // Function set the selectedColumn state on the onChange of the dropdown
  const handleDropdownChange = (event: any, option: any) => {
    setSelectedColumn(option.key);
  };
  // Function set the SearchTerm state on the onChange of the text
  const handleTextFieldChange = (event: any) => {
    setSearchTerm(event.target.value);
    if (selectedColumn === "") {
      setSelectedColumn("any");
    }
  };

  useEffect(() => {
    handleSearch();
  }, [selectedColumn, searchTerm]);

  // Function to handle the search
  const handleSearch = () => {
    console.log("searchTerm in search ", searchTerm);
    console.log("searchTerm in search ", props.itemsOrg);

    let results = props.itemsOrg.filter((item: any) => {
      if (selectedColumn === "any" || selectedColumn === "") {
        // Search specifically in userEmail and assignedLegalBases fields only

        // Check userEmail field
        if (item.userEmail && typeof item.userEmail === "string") {
          if (item.userEmail.toLowerCase().includes(searchTerm.toLowerCase())) {
            return true;
          }
        }

        // Check assignedLegalBases field
        if (item.assignedLegalBases && Array.isArray(item.assignedLegalBases)) {
          for (const legalBasis of item.assignedLegalBases) {
            if (legalBasis.name && legalBasis.name.toLowerCase().includes(searchTerm.toLowerCase())) {
              return true;
            }
          }
        }

        return false;
      } else {
        const columnValue = item[selectedColumn];

        // Handle assignedLegalBases specifically
        if (selectedColumn === "assignedLegalBases" && Array.isArray(columnValue)) {
          return columnValue.some((legalBasis: any) =>
            legalBasis.name && legalBasis.name.toLowerCase().includes(searchTerm.toLowerCase())
          );
        }

        // Handle string properties (like userEmail)
        if (typeof columnValue === "string") {
          return columnValue.toLowerCase().includes(searchTerm.toLowerCase());
        }

        // Handle number properties
        if (typeof columnValue === "number") {
          return String(columnValue).includes(searchTerm);
        }

        // Handle boolean properties
        if (typeof columnValue === "boolean") {
          return (
            (columnValue === true && searchTerm.toLowerCase() === "true") ||
            (columnValue === false && searchTerm.toLowerCase() === "false")
          );
        }

        return false;
      }
    });

    if (searchTerm == "") {
      results = props.itemsOrg;
    }
    setItemsSearch(results);
  };

  const iconStyleProps: FluentIconsProps = {
    primaryFill: "#0078D4",
    className: styles.filterIcon,
  };

  function onRenderPrefix() {
    return <Filter20Filled aria-label={"Filter"} {...iconStyleProps} />;
  }

  return (
    <Stack className={styles.OuterStackContainer}>
      <StackItem>
        <Stack className={styles.InnerStack} horizontal>
          <StackItem className={styles.InnerStackItem}>
            <Dropdown
              selectedKey={selectedColumn}
              options={props.options}
              styles={{ ...props.dropdownStyles }}
              placeholder="Select column to filter by"
              defaultSelectedKey="any"
              onChange={handleDropdownChange}
              data-testid='quicksearch-dropdown'
            />
          </StackItem>
          <StackItem className={styles.InnerStackItem}>
            <TextField
              onRenderPrefix={onRenderPrefix}
              placeholder="Start typing to filter the list"
              className={styles.searchbar}
              onChange={handleTextFieldChange}
              styles={{ fieldGroup: { ...props.textFieldStyles.fieldGroup } }}
              data-testid="search-text-field"
            />
          </StackItem>
        </Stack>
      </StackItem>
      {/* <EUSLBModal options={props.columns} /> */}
    </Stack>
  );
}

export default QuickSearch;
